/* eslint-disable no-console */
import { httpModule } from '@shared/http';
import { Propietor } from '@services/propietor';
import { Bank } from '../bank';

export type BankAccount = {
    id: number;
    cbu: string;
    cuit: string;
    isOrganizationAccount: boolean;
    holderName: string;
    bankName: string;
    isDefault?: false;
    name?: string;
};

export type Account = {
    name: string;
    id: number;
    isDefault: boolean;
    amount: number;
    type: string;
    bankName?: string;
    bankAccount: BankAccount | null;
    user?: object;
};

export type PropietorBankAccount = {
    id?: number;
    cbu: string;
    cuit: string;
    isDefault: boolean;
    isOrganizationAccount: boolean;
    holderName: string;
    bankName: string;
    bank: Bank;
    name: string;
    accountType: 'SavingsAccount' | 'CheckingAccount';
    propietorAccount: PropietorAccount;
}

export type PropietorAccount = {
    id: number;
    amount: number;
    defaultBankAccount: number | null;
    propietor: Propietor | null;
    propietorBankAccounts: PropietorBankAccount | null;
};

export async function fetchAccounts(page?: number, limit?: number) {
    try {
        return await httpModule.get('/accounts', {
            params: { page, limit }
        });
    } catch (ex) {
        console.warn(`Error fetching accounts: ${ex}`);
    }
}


export async function fetchAccountsByPropietorId(propietorId: number) {
    try {
        return await httpModule.get(`propietor-accounts/by-propietor/${propietorId}`);
    } catch (ex) {
        console.warn(`Error fetching propietor accounts: ${ex}`);
    }
}

export async function fetchAccountsByTenantId(tenantId: number, page?: number, limit?: number) {
    try {
        return await httpModule.get(`tenant-accounts/by-tenant/${tenantId}`, {
            params: { page, limit }
        });
    } catch (ex) {
        console.warn(`Error fetching propietor accounts: ${ex}`);
    }
}

export async function postAccount(account: any) {
    try {
        return await httpModule.post('/accounts', account);
    } catch (ex) {
        console.warn(`Error posting an account: ${ex}`);
    }
}

export async function postBankAccount(bankAccount: any) {
    try {
        return await httpModule.post('/bank-account', bankAccount);
    } catch (ex) {
        console.warn(`Error posting an account: ${ex}`);
    }
}

export async function getAccountById(id: number) {
    try {
        return await httpModule.get(`/accounts/${id}`);
    } catch (ex) {
        console.warn(`Error getting an account: ${ex}`);
    }
};

export async function getTotalAmountFromAccounts() {
    try {
        return await httpModule.get(`/accounts/totals`);
    } catch (ex) {
        console.warn(`Error getting the total amount: ${ex}`);
    }
};

export async function getTotalAmountFromPropietorAccounts() {
    try {
        return await httpModule.get(`/propietor-accounts/totals`);
    } catch (ex) {
        console.warn(`Error getting the total amount: ${ex}`);
    }
};

export async function fetchTenantAccounts(tenantId: number) {
    try {
        return await httpModule.get(`/tenant-accounts/by-tenant/${tenantId}`, {
        });
    } catch (ex) {
        console.warn(`Error fetching tenat accounts: ${ex}`);
    }
}
export async function deleteAccount(id: number) {
    try {
        return await httpModule.delete('/accounts', {
            params: { id }
        });
    } catch (ex) {
        console.warn(`Error deleting account: ${ex}`);
    }
}

export async function fetchBanksByPropietor(id: number) {
    try {
        return await httpModule.get(`/bank-account/by-propietor/${id}`);
    } catch (ex) {
        console.warn(`Error fetching banks: ${ex}`);
    }
}

export async function fetchPropietorAccount(id: number) {
    try {
        return await httpModule.get(`/propietor-accounts/account-by-propietor/${id}`);
    } catch (ex) {
        console.warn(`Error fetching banks: ${ex}`);
    }
}